export default __webpack_public_path__ + "static/media/bl.bfa68d22.svg";